import { ArrowUpRight, Flame } from "lucide-react";
import { useSite } from "../../context/SiteContext";

const Chip = ({ m }) => {
  const { trial } = useSite();
  return (
  <a href={trial} target="_blank" rel="noreferrer" data-testid={`week-match-${m.id}`}
    className="group flex items-center gap-3 px-5 border-r border-white/10 hover:bg-white/5 transition-colors">
    <span className="rounded-full bg-white/10 px-2.5 py-0.5 text-xs font-semibold text-white">{m.day}</span>
    <span className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-extrabold tracking-wider ${m.highlight === "DERBİ" ? "derby-badge text-[#2a1600]" : "bg-[#ffcf5c]/15 text-[#ffe08a]"}`}>
      <Flame size={10} /> {m.highlight}
    </span>
    <span className="font-display text-sm font-semibold text-white">{m.home} <span className="text-[#c9c6f0] font-normal">-</span> {m.away}</span>
    {m.state === "in" ? (
      <span className="inline-flex items-center gap-1.5 rounded-full bg-red-500/15 px-2.5 py-0.5 text-xs font-bold text-red-300">
        <span className="h-1.5 w-1.5 rounded-full bg-red-500 animate-pulse" />CANLI {m.home_score ?? 0}-{m.away_score ?? 0}
      </span>
    ) : (
      <span className="font-display text-sm font-extrabold text-[#ffe08a]">{m.state === "post" ? "MS" : m.time}</span>
    )}
  </a>
  );
};

export default function WeekCalendar({ list }) {
  const { trial } = useSite();
  const nowS = Date.now() / 1000;
  const items = list.filter((m) => m.state !== "post" && nowS < m.ts + 3 * 3600);
  if (!items.length) return null;
  const loop = [...items, ...items];

  return (
    <div className="relative flex items-stretch h-11 border-b border-[#ffcf5c]/20 bg-[#100e45]/95 backdrop-blur-xl" data-testid="week-calendar">
      <div className="flex items-center gap-2 px-4 md:px-6 bg-[#ffcf5c] text-[#1a1033] shrink-0 z-10">
        <Flame size={14} />
        <p className="font-display text-[11px] md:text-xs font-extrabold uppercase whitespace-nowrap">
          <span className="hidden sm:inline">Haftanın </span>Büyük Maçları
        </p>
      </div>
      <div className="relative overflow-hidden flex-1 flex items-center [mask-image:linear-gradient(90deg,transparent,#000_5%,#000_95%,transparent)]">
        <div className="marquee-track flex w-max items-center whitespace-nowrap hover:[animation-play-state:paused]" style={{ animationDuration: `${Math.max(30, items.length * 9)}s` }}>
          {loop.map((m, i) => <Chip key={`${m.id}-${i}`} m={m} />)}
        </div>
      </div>
      <a href={trial} target="_blank" rel="noreferrer" data-testid="week-calendar-trial-btn"
        className="group hidden md:inline-flex items-center gap-1.5 px-5 shrink-0 text-sm font-semibold text-[#ffe08a] hover:bg-[#ffcf5c] hover:text-[#1a1033] transition-colors">
        Ücretsiz Test <ArrowUpRight size={15} className="transition-transform group-hover:rotate-45" />
      </a>
    </div>
  );
}
